export default __webpack_public_path__ + "static/media/arrowtrendup-1.ae7b0b8a.svg";